import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productSku: {
    defaultMessage: 'SKU: {sku}',
    id: 'DfmwVQ',
    description: 'Product SKU',
  },
  selectLocation: {
    defaultMessage: 'Select Location',
    id: 'YlGplH',
    description: 'Placeholder for location selection in bundle sub-row',
  },
});
